// extracted by mini-css-extract-plugin
export default {"root":"ListingLikes_root__42ndr","likes":"ListingLikes_likes__tP3hN marketplaceSmallFontStyles","iconHeart":"ListingLikes_iconHeart__oWFjU"};